import React, { memo, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getSowDataPath } from 'core/routing/paths';
import RequestProvidedDate from 'shared/Table/shared/RequestProvidedDate';

interface ISowDataTableDateColumnItemProps {
  viewPath?: string,
  isRequest?: boolean
  requestProvidedDate: string
}

const SowDataTableDateColumnItem: React.FC<ISowDataTableDateColumnItemProps> = ({
  viewPath,
  isRequest,
  requestProvidedDate,
}) => {
  const { wirelineEngagementId, customerId } = useParams();

  const path = useMemo(() => {
    const startPath = getSowDataPath(wirelineEngagementId, customerId);

    return `${startPath}${viewPath}`;
  }, [viewPath, customerId, wirelineEngagementId]);

  return (
    <RequestProvidedDate
      viewPath={path}
      isRequest={isRequest}
      requestProvidedDate={requestProvidedDate}
    />
  );
};

SowDataTableDateColumnItem.defaultProps = {
  isRequest: false,
  viewPath: '',
};

export default memo(SowDataTableDateColumnItem);
